import React from "react";
import qrcode from "../../../assets/img/qr-code.webp"
const BankDetails = () => {
  return (
    <>
      <div className="row d-flex justify-content-start align-items-center">
        <div className="col-12 col-md-8">
          <label class="text-sm ms-0">Bank Details</label>
          <h4>Coming Soon....</h4>
          {/* 
          <label class="text-sm ms-0 mt-2 d-block text-capitalize">Bank Bame : Dubai Bank</label>
          <p class="mb-2 text-dark text-sm text-capitalize">account no. : 5462568546</p>
          <p class="mb-2 text-dark text-sm text-capitalize">IFSC Code : <span className="text-uppercase">db0000000</span></p>
         */}
        </div>
        {/* <div className="col-12 col-md-4 text-center">
            <img src={qrcode} className="img-fluid" alt="" />
        </div> */}
      </div>
    </>
  );
};

export default BankDetails;
